import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {
  message!: any;

  constructor() { }

  ngOnInit(): void {
    let breadcrumbStatus: any = localStorage.getItem('breadcrumbStatus')
    this.message = JSON.parse(breadcrumbStatus);
  }

}
